<div class="page">
    <div class="container-fluid">
        <div class="row page-header">
            <div class="col-md-6">
                <h3>Flexible Timetable <br>
                <small>{{batch.course}} - Batch {{batch.start_year}}</small>  &nbsp;
                <small>Current Semester: {{batch.current_semester}}</small>
                </h3>
            </div>

            <div class="col-md-6 text-right">
                <button class="btn btn-secondary" (click)="openCopyModal()">
                    <i class="fa fa-copy"></i> Copy Structure
                </button>
                &nbsp;
                <button class="btn btn-action" (click)="openBulkCreateModal()">
                    <i class="fa fa-plus"></i> Bulk Create Slots
                </button>
            </div>
        </div>

        <div class="page-body">
            
            <!-- Week Navigation -->
            <div class="week-navigation mb-4">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary" (click)="prevWeek()">
                            <i class="fa fa-chevron-left"></i> Previous
                        </button>
                        <button class="btn btn-outline-primary ml-2" (click)="nextWeek()">
                            Next <i class="fa fa-chevron-right"></i>
                        </button>
                    </div>
                    <div class="col-md-4 text-center">
                        <h5 class="week-range">
                            {{weekDates[0]?.date | date:'MMM dd'}} - {{weekDates[6]?.date | date:'MMM dd, yyyy'}}
                        </h5>
                    </div>
                    <div class="col-md-4 text-right">
                        <button class="btn btn-primary" (click)="goToToday()">
                            <i class="fa fa-calendar"></i> Today
                        </button>
                    </div>
                </div>
            </div>

            <!-- Loading Spinner -->
            <div *ngIf="loading" class="text-center p-5">
                <i class="fa fa-spinner fa-spin fa-3x"></i>
                <p>Loading timetable...</p>
            </div>

            <!-- Timetable Grid -->
            <div *ngIf="!loading" class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table table-bordered timetable-grid">
                            <thead>
                                <tr>
                                    <th *ngFor="let day of weekDates" class="text-center">
                                        <strong>{{day.dayName}}</strong><br>
                                        <small>{{day.date | date:'MMM dd'}}</small>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td *ngFor="let day of weekDates" class="day-column" [attr.data-date]="day.dateString">
                                        
                                        <!-- Slots for this day -->
                                        <div *ngFor="let slot of getSlotsForDate(day.dateString)" 
                                             class="slot-card mb-3"
                                             [ngClass]="{'slot-break': slot.is_break == 1, 'slot-empty': !slot.data.subject && slot.is_break == 0, 'slot-assigned': slot.data.subject}">
                                            
                                            <!-- Break Slot -->
                                            <div *ngIf="slot.is_break == 1" class="slot-break-content">
                                                <div class="slot-time-badge">
                                                    <i class="fa fa-coffee"></i> {{slot.start_time}} - {{slot.end_time}}
                                                </div>
                                                <div class="slot-subject text-center mt-2">
                                                    <strong>BREAK</strong>
                                                </div>
                                                <div class="slot-actions text-center mt-2">
                                                    <a href="javascript:void(0)" (click)="openEditSlotModal(slot)" class="btn-icon" title="Edit Time">
                                                        <i class="fa fa-edit"></i>
                                                    </a>
                                                    <a href="javascript:void(0)" (click)="deleteSlot(slot.slot_id)" class="btn-icon text-danger ml-2" title="Delete">
                                                        <i class="fa fa-trash"></i>
                                                    </a>
                                                </div>
                                            </div>

                                            <!-- Regular Slot -->
                                            <div *ngIf="slot.is_break == 0" class="slot-content">
                                                <div class="slot-time-badge mb-2">
                                                    <i class="fa fa-clock"></i> {{slot.start_time}} - {{slot.end_time}}
                                                </div>
                                                <div class="slot-subject-area" (click)="openAssignModal(slot)" [class.clickable]="true">
                                                    <div class="slot-subject" *ngIf="slot.data.subject">
                                                        <strong>{{slot.data.subject}}</strong>
                                                    </div>
                                                    <div class="slot-subject text-muted" *ngIf="!slot.data.subject">
                                                        <i class="fa fa-plus-circle"></i> Click to assign
                                                    </div>
                                                    <div class="slot-faculty" *ngIf="slot.data.faculty.name">
                                                        <i class="fa fa-user"></i> {{slot.data.faculty.name}}
                                                    </div>
                                                </div>
                                                <div class="slot-actions mt-2">
                                                    <a *ngIf="slot.data.topic_id > 0" 
                                                       href="javascript:void(0)" 
                                                       (click)="navigateToAttendance(slot.slot_id)"
                                                       class="btn-icon btn-icon-success"
                                                       title="Mark Attendance">
                                                        <i class="fa fa-check-circle"></i>
                                                    </a>
                                                    <a href="javascript:void(0)" (click)="openEditSlotModal(slot)" class="btn-icon" title="Edit Time">
                                                        <i class="fa fa-edit"></i>
                                                    </a>
                                                    <a href="javascript:void(0)" (click)="deleteSlot(slot.slot_id)" class="btn-icon btn-icon-danger" title="Delete">
                                                        <i class="fa fa-trash"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Add Slot Button -->
                                        <div class="text-center mt-3">
                                            <button class="btn btn-sm btn-outline-primary btn-block" (click)="openAddSlotModal(day.dateString)">
                                                <i class="fa fa-plus"></i> Add Slot
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Modal: Add Slot -->
<div class="modal fade" id="modal-add-slot" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Add Time Slot</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <form #fAddSlot="ngForm" (ngSubmit)="addSlot()" ngNativeValidate>
                    <div class="form-group">
                        <label>Date</label>
                        <input type="text" class="form-control" [(ngModel)]="newSlot.date" name="date" readonly>
                    </div>
                    <div class="form-group">
                        <label>Start Time</label>
                        <input type="time" class="form-control" [(ngModel)]="newSlot.start_time" name="start_time" required>
                    </div>
                    <div class="form-group">
                        <label>End Time</label>
                        <input type="time" class="form-control" [(ngModel)]="newSlot.end_time" name="end_time" required>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" [(ngModel)]="newSlot.is_break" name="is_break" [value]="1">
                            This is a break
                        </label>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="addSlot()">Add Slot</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Edit Slot -->
<div class="modal fade" id="modal-edit-slot" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edit Time Slot</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <form #fEditSlot="ngForm" (ngSubmit)="updateSlot()" ngNativeValidate>
                    <div class="form-group">
                        <label>Start Time</label>
                        <input type="time" class="form-control" [(ngModel)]="editSlot.start_time" name="start_time" required>
                    </div>
                    <div class="form-group">
                        <label>End Time</label>
                        <input type="time" class="form-control" [(ngModel)]="editSlot.end_time" name="end_time" required>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" [(ngModel)]="editSlot.is_break" name="is_break" [value]="1">
                            This is a break
                        </label>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="updateSlot()">Update</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Assign Subject/Faculty -->
<div class="modal fade" id="modal-assign" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Assign Subject & Faculty</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <form #fAssign="ngForm" (ngSubmit)="assignSlotData()" ngNativeValidate>
                    <div class="form-group">
                        <label>Subject</label>
                        <select [(ngModel)]="selectedSlot.topic_id" name="topic_id" class="form-control" 
                                (change)="setDisplayText($event.target.value)" required>
                            <option value="">-- Select Subject --</option>
                            <option *ngFor="let topic of topics" [value]="topic.id">{{topic.topic}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Display Text</label>
                        <input type="text" class="form-control" [(ngModel)]="selectedSlot.subject" name="subject">
                    </div>
                    <div class="form-group">
                        <label>Faculty</label>
                        <select [(ngModel)]="selectedSlot.faculty.id" name="faculty_id" class="form-control" 
                                (change)="setSlotFacultyName($event.target.value)">
                            <option value="0">-- Select Faculty --</option>
                            <option *ngFor="let faculty of facultiesDrop" [value]="faculty.id">{{faculty.name}}</option>
                        </select>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="assignSlotData()">Save</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Copy Structure -->
<div class="modal fade" id="modal-copy-structure" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Copy Day Structure</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Copy From Date</label>
                    <input type="date" class="form-control" [(ngModel)]="copyFromDate">
                </div>
                <div class="form-group">
                    <label>Copy To Dates (comma separated: YYYY-MM-DD)</label>
                    <textarea class="form-control" [(ngModel)]="copyToDates" rows="3" 
                              placeholder="2024-12-25, 2024-12-26, 2024-12-27"></textarea>
                    <small class="form-text text-muted">Enter dates separated by commas</small>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="copyStructure()">Copy</button>
            </div>
        </div>
    </div>
</div>

<!-- Modal: Bulk Create -->
<div class="modal fade" id="modal-bulk-create" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Bulk Create Slots</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Dates (comma separated: YYYY-MM-DD)</label>
                    <textarea class="form-control" [(ngModel)]="bulkDates" rows="2" 
                              placeholder="2024-12-23, 2024-12-24, 2024-12-25"></textarea>
                </div>
                
                <label>Slot Structure</label>
                <div *ngFor="let slot of bulkSlotStructure; let i = index" class="card mb-2 p-2">
                    <div class="row">
                        <div class="col-md-4">
                            <input type="time" class="form-control" [(ngModel)]="slot.start_time" placeholder="Start">
                        </div>
                        <div class="col-md-4">
                            <input type="time" class="form-control" [(ngModel)]="slot.end_time" placeholder="End">
                        </div>
                        <div class="col-md-3">
                            <label>
                                <input type="checkbox" [(ngModel)]="slot.is_break"> Break
                            </label>
                        </div>
                        <div class="col-md-1">
                            <button class="btn btn-sm btn-danger" (click)="removeBulkSlotRow(i)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <button class="btn btn-sm btn-secondary" (click)="addBulkSlotRow()">
                    <i class="fa fa-plus"></i> Add Slot
                </button>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" (click)="bulkCreateSlots()">Create</button>
            </div>
        </div>
    </div>
</div>
